import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import NoStudyAssociatedErrorPageContent from "app/components/study/errors/NoStudyAssociatedErrorPageContent";
import NoSingleStudyAssociatedErrorPageContent from "app/components/study/errors/NoSingleStudyAssociatedErrorPageContent";

const NoStudyAssociatedErrorPage = (props) => {
  const { t } = useTranslation();

  return (
    <Page
      hasDrawer={false}
      pageTitle={t("NoStudyAssociation.NoStudyAssociationTitle")}
      hasBackButton={false}
      contentComponent={
        props.singleStudy
          ? NoSingleStudyAssociatedErrorPageContent
          : NoStudyAssociatedErrorPageContent
      }
      {...props}
    />
  );
};

export default NoStudyAssociatedErrorPage;
